import { render, staticRenderFns } from "./druglist.vue?vue&type=template&id=b7c2dc62&scoped=true&"
import script from "./druglist.vue?vue&type=script&lang=js&"
export * from "./druglist.vue?vue&type=script&lang=js&"
import style0 from "./druglist.vue?vue&type=style&index=0&id=b7c2dc62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c2dc62",
  null
  
)

export default component.exports